module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "gForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fwVersionInputVisable),
      expression: "fwVersionInputVisable"
    }],
    attrs: {
      "label": _vm.$t('terminal.appBind.label_version'),
      "prop": "version"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8391a5",
      "font-size": "12px",
      "line-height": "2",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.verTips1')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_fwType'),
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.typeHolder
    },
    on: {
      "change": _vm.selectTypeChange
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.$firmwareTypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mechanism"
    }
  }, [(_vm.mechanismData) ? _c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_chooseFile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "drag": "",
      "accept": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [(_vm.fileList.length > 0) ? _c('span', [_c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('i', {
    staticClass: "el-icon-check",
    staticStyle: {
      "color": "#13CE66"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulSuccess')))])]) : _c('span', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5198bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/firmware/edit.vue
// module id = 964
// module chunks = 0